import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { HttpService } from '../http.service';
import { PlatformLocation } from '@angular/common';
import { Proflie } from '../profile';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  allItems: Proflie[];
  seachItemList: Object;
  faSearch = faSearch;
  searchForm: FormGroup;
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  autoCompleteList: Object;
  baseUrl: string;

  @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
  @Output() onSelectedOption = new EventEmitter();

  constructor(
    private _http: HttpService,
    private fb: FormBuilder,
    platformLocation: PlatformLocation) {
      // console.log(platformLocation);
      this.baseUrl = (platformLocation as any).location.origin;
      // console.log(this.baseUrl);
     }

  ngOnInit(): void {

    this._http.getPosts().subscribe(posts => {
      this.allItems = posts;
      this._http.postsData = posts;
      // console.log(this.allItems);
    });

    // when user types something in input, the value changes will come through this
    this.myControl.valueChanges.subscribe(userInput => {
      this.autoCompleteExpenseList(userInput);
    });

    this.searchForm = this.fb.group({
      search: ['', Validators.required]
    });
  }

  private autoCompleteExpenseList(input) {
    this.seachItemList = this.filterSeachItems(input)
    this.autoCompleteList = this.seachItemList;
  }

  // this is where filtering the data happens according to you typed value
  filterSeachItems(val) {
    var seachItemList = []
    if (typeof val != "string") {
        return [];
    }
    if (val === '' || val === null) {
        return [];
    }
    return val ? this.allItems.filter(s => s.title.toLowerCase().indexOf(val.toLowerCase()) != -1)
        : this.allItems;
  }

}
